import React from 'react';
import CTASection from './CTASection';
import './AboutUsPage.css';
import Footer from "./footer";

const AboutUsPage = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="about-hero" style={{ cursor: "url('/images/shell.png'), auto" }}>
        <div className="about-hero-overlay">
          <h1>ما، که هستیم؟</h1>
          <p>باور ما به اصالت، هنر و کیفیت است.</p>
        </div>
      </section>




      {/* Our Story Section 1 */}
      <section className="our-story1" style={{ cursor: "url('/images/shell.png'), auto" }}>
        <div className="story-text1">
          <h2>آغاز راه و شکل‌گیری</h2>
          <p>
            شرکت گوهر صدف دریا فعالیت خود را در سال ۱۳۷۹ با ۶۰ عضو در حوزه‌های قالی، گلیم، گبه و طراحی آغاز کرد. این حرکت با هدف ایجاد فرصت شغلی برای زنان خودسرپرست و بدسرپرست، ابتدا در شهرستان ساوجبلاغ شکل گرفت و در سال ۱۳۸۹ به تهران منتقل شد. سرمایه اولیه هر عضو ۱۰۰٬۰۰۰ ریال بود که امروز به ۳٬۰۰۰٬۰۰۰ ریال افزایش یافته است.
          </p>
        </div>
        <div className="story-image1">
          <img src="/images/firooze.png" alt="درباره ما" />
        </div>
      </section>


      {/* Our Story Section 2 */}
      <section className="our-story2" style={{ cursor: "url('/images/shell.png'), auto" }}>
        <div className="story-image2">
          <img src="/images/ghalam.png" alt="در گوهر صدف، ما روایت‌گر فرهنگ و هنر سرزمین‌مان هستیم." />
        </div>
        <div className="story-text2">
          <h2>اشتغال‌زایی و توانمندسازی زنان</h2>
          <p>
           امروزه، این شرکت سالانه برای حدود ۲۰۰ تا ۳۰۰ نفر از زنان علاقه‌مند و خودسرپرست شغل ایجاد می‌کند. این بانوان پس از دریافت مدرک فنی‌وحرفه‌ای و کارت اتحادیه، تحت پوشش بیمه قرار گرفته و در منازل خود به تولید آثار دستباف می‌پردازند. تاکنون بیش از ۷۰۰ نفر در این مسیر فعالیت داشته‌اند و نقش ارزشمندی در تقویت اقتصاد خانواده و جامعه ایفا کرده‌اند.
          </p>
        </div>

      </section>

      {/* Our Story Section 3 */}
      <section className="our-story3" style={{ cursor: "url('/images/shell.png'), auto" }}>

        <div className="story-text3">
          <h2>زمینه‌های فعالیت و افتخارات</h2>
          <p>
            فعالیت‌های گوهر صدف دریا شامل آموزش، تولید و فروش قالی، تابلو فرش، انواع گلیم، گبه، کیف و حوله، جاجیم، فرش روی سفال، مکمل‌های داری، عکاسی با لباس‌های سنتی اقوام، طراحی و رنگرزی فرش است. این تلاش‌ها منجر به کسب افتخاراتی چون دو بار انتخاب به‌عنوان تعاونی برتر شهرستان ساوجبلاغ، تعاونی برتر جشنواره فرش، تعاونی برتر استان تهران و دریافت تندیس نمایشگاه توانمندی استان البرز شده است.
          </p>
        </div>
        <div className="story-image3">
          <img src="/images/candle.png" alt="در گوهر صدف، ما روایت‌گر فرهنگ و هنر سرزمین‌مان هستیم." />
        </div>
      </section>




      {/* Our Values Section */}
      <section className="values" style={{ cursor: "url('/images/shell.png'), auto" }}>
        <h2>ارزش‌های ما</h2>
        <div className="value-cards">
          <div className="value-card">
            <img src="/images/icons/authenticity.png" alt="اصالت" />
            <p>اصالت</p>
          </div>
          <div className="value-card">
            <img src="/images/icons/durability.png" alt="پایداری" />
            <p>پایداری</p>
          </div>
          <div className="value-card">
            <img src="/images/icons/handmade.png" alt="دست‌ساز" />
            <p>دست‌ساز</p>
          </div>
        </div>
      </section>




      {/* Call to Action */}
      <CTASection />
      
      



      {/* Footer */}

      <Footer />


    </>
  );
};

export default AboutUsPage;
